<template>
    <div class="graph-wrapper">
        <fan-graph-summary-header :offer-view="offerView" @openCadHeader="openCadHeader"/>

        <CadTable v-show="!offerView" v-if="cadHeaderVisible"/>
        <div class="fanGraphSummary" :class="{hidden: cadHeaderVisible || countSimilarFans == 0 }">
        </div>
        <div class="no-parameters" v-show="!offerView" v-if="workPointPressure == 0"><span>{{translate("enter_parameters")}}</span>
        </div>
        <div class="no-result" v-show="!offerView" v-else-if="countSimilarFans == 0">
            <span>{{translate("no_result")}}</span></div>
        <fan-graph-summary-footer
                :characteristic-line-show="true"
                :nominal-point-show="true"
                :power-line-show="this.$store.state && this.$store.state.showPowerLine"
                :requested-point-show="true"
                :work-point-show="true"
                :circle-radius="footerCircleRadius" ref="graphFooter">
        </fan-graph-summary-footer>
    </div>
</template>

<script>
    import {measurementShow} from "../../../measurementShow";
    import FanGraphSummaryHeader from "./FanGraphSummaryHeader"
    import FanGraphSummaryFooter from "./FanGraphSummaryFooter"
    import CadTable from "./CadTable";

    export default {
        name: "FanGraphSummary",
        data() {
            return {
                watchLocked: false,
                obiekt: '',
                cadHeaderVisible: false,
                tescik: true
            }
        },
        props: {
            offerView: {
                default: false
            },

            footerCircleRadius: 0
        },
        components: {
            CadTable,
            FanGraphSummaryHeader,
            FanGraphSummaryFooter
        },
        computed: {

            countSimilarFans() {
                this.manageSelectedFan();

                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData.length;
                else
                    return 0;
            },

            graphMeshSettingsX() {
                return this.$store.state.graphMeshSettings.x;
            },
            graphMeshSettingsY() {
                return this.$store.state.graphMeshSettings.y;
            },
            selectedFan() {
                return this.$store.state.selectFanHandler;
            },
            partsOfTheGraphChanged() {
                return this.$store.state.partsOfTheGraphChanged;
            },
            workPointPressure() {
                return this.$store.state.fourthStepParametersSelected['pressure'].value;
            },
            workPointPressureType() {
                return this.$store.state.fourthStepParametersSelected['pressure'].options[0].elements[0].active;
            },
            fourthStepParamsLastUnitChanges() {
                return this.$store.state.fourthStepParamsLastUnitChanges.subId;
            },

            workPointPerformance() {
                return this.$store.state.fourthStepParametersSelected['performance'].value;
            },

            workPointTemperature() {
                return this.$store.state.fourthStepParametersSelected['temperature'].value;
            },

            workPointAboveSea() {
                return this.$store.state.fourthStepParametersSelected['above_sea'].value;
            },

            workPointAmount() {
                return this.$store.state.fourthStepParametersSelected['material_amount'].value;
            },
            //
            workPointAmountUnit() {
                return this.$store.state.fourthStepParametersSelected['material_density'].value;
            },

            workPointFrequency() {
                return this.$store.state.fourthStepParametersSelected['workPointFrequency'].value;
            },

            workPointRotationSpeed() {
                return this.$store.state.fourthStepParametersSelected['workPointRotationSpeed'].value;
            },

            workPointBaseFrequency50() {
                return this.$store.state.fourthStepParametersSelected['network_frequency'].options[0].elements[0].active;
            },

        },
        watch: {
            graphMeshSettingsX() {
                // NVS-200 - dodanie zabezpieczenia na this.obiekt.graphsSummary
                if (this.$store.state.graphMeshSettings.x && this.obiekt.graphsSummary)
                    this.obiekt.graphsSummary.graph.graph.config = {
                        x: {step: this.$store.state.graphMeshSettings.x.step},
                        y: {step: this.$store.state.graphMeshSettings.y.step}
                    };
            },
            graphMeshSettingsY() {
                // NVS-200 - dodanie zabezpieczenia na this.obiekt.graphsSummary
                if (this.$store.state.graphMeshSettings.y && this.obiekt.graphsSummary)
                    this.obiekt.graphsSummary.graph.graph.config = {
                        x: {step: this.$store.state.graphMeshSettings.x.step},
                        y: {step: this.$store.state.graphMeshSettings.y.step}
                    };
            },
            workPointBaseFrequency50() {
                if (this.$store.state.fourthStepParametersSelected['network_frequency'].options[0].elements[0].active) {
                    this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = 50;
                } else {
                    this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = 60;
                }

                if (this.$store.state.selectedFan && this.$store.state.selectedFan.engine_rpm) {
                    this.$store.state.fourthStepParametersSelected['workPointRotationSpeed'].value = this.$store.state.fourthStepParametersSelected['workPointFrequency'].value / 50 * parseFloat(this.$store.state.selectedFan.engine_rpm);
                }
            },
            selectedFan() {
                // if (this.$store.state.fourthStepParametersSelected['network_frequency'].options[0].elements[0].active) {
                //     this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = 50;
                // } else {
                //     this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = 60;
                // }
                let selectedWorkPointCopy = {
                    workPointPressure: 0,
                    workPointPerformance: 0,
                    workPointPerformanceHour: 0
                };

                if (this.$store.state.selectedWorkPoint && this.$store.state.setWorkPointWhenFanHandlerFired) {
                    selectedWorkPointCopy.workPointPressure = this.$store.state.selectedWorkPoint.workPointPressure;
                    selectedWorkPointCopy.workPointPerformance = this.$store.state.selectedWorkPoint.workPointPerformance;
                    selectedWorkPointCopy.workPointPerformanceHour = this.$store.state.selectedWorkPoint.workPointPerformanceHour;
                }

                this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = this.$store.state.activeFun.params.work_frequency;

                if (this.$store.state.selectedFan && this.$store.state.selectedFan.engine_rpm) {
                    this.$store.state.fourthStepParametersSelected['workPointRotationSpeed'].value = this.$store.state.fourthStepParametersSelected['workPointFrequency'].value / 50 * parseFloat(this.$store.state.selectedFan.engine_rpm);
                }

                this.obiekt.init(this.$store);
                this.obiekt.refreshAxis();
                this.obiekt.calc();
                this.obiekt.graphsSummary.draw();
                //
                // this.calculateFans();

                if (this.$store.state.selectedWorkPoint && this.$store.state.setWorkPointWhenFanHandlerFired) {
                    this.$store.state.setWorkPointWhenFanHandlerFired = false;
                    this.obiekt.graphsSummary.data.workPointPressure = selectedWorkPointCopy.workPointPressure;
                    this.obiekt.graphsSummary.data.workPointPerformance = selectedWorkPointCopy.workPointPerformance;
                    this.obiekt.graphsSummary.data.workPointPerformanceHour = selectedWorkPointCopy.workPointPerformanceHour;

                    this.obiekt.graphsSummary.changed.call(this);
                }

            },
            partsOfTheGraphChanged() {
                // NVS-200 - dodanie zabezpieczenia, żeby za wcześnie nie wywołać watchera
                if (!this.obiekt.graphsSummary || !this.obiekt.data.characteristic.TotalPressure) {
                    return;
                }
                this.obiekt.refreshAxis();
                this.obiekt.graphsSummary.draw();

                let selectedWorkPointCopy = {
                    workPointPressure: 0,
                    workPointPerformance: 0,
                    workPointPerformanceHour: 0
                };

                if (this.$store.state.selectedWorkPoint) {
                    selectedWorkPointCopy.workPointPressure = this.$store.state.selectedWorkPoint.workPointPressure;
                    selectedWorkPointCopy.workPointPerformance = this.$store.state.selectedWorkPoint.workPointPerformance;
                    selectedWorkPointCopy.workPointPerformanceHour = this.$store.state.selectedWorkPoint.workPointPerformanceHour;
                }

                this.calculateFans();

                if (this.$store.state.selectedWorkPoint) {
                    this.obiekt.graphsSummary.data.workPointPressure = selectedWorkPointCopy.workPointPressure;
                    this.obiekt.graphsSummary.data.workPointPerformance = selectedWorkPointCopy.workPointPerformance;
                    this.obiekt.graphsSummary.data.workPointPerformanceHour = selectedWorkPointCopy.workPointPerformanceHour;

                    this.obiekt.graphsSummary.changed.call(this);
                }
            },
            workPointPressure() {
                // if (window.mouseDown)
                //     return;
                //
                // this.obiekt.calc();
                //
                // this.calculateFans();
            },
            fourthStepParamsLastUnitChanges() {
                if (this.$store.state.fourthStepParamsLastUnitChanges.userChanged && this.$store.state.fourthStepParamsLastUnitChanges.unit && this.$store.state.fourthStepParamsLastUnitChanges.unit.id) {

                    if (this.$store.state.ValueUnitMap.hasOwnProperty(this.$store.state.fourthStepParamsLastUnitChanges.unitType)) {
                        this.loadChangedUnit(this.$store.state.fourthStepParamsLastUnitChanges.unitType, this.$store.state.fourthStepParamsLastUnitChanges.unitType);
                    }
                }
                let selectedWorkPointCopy = {
                    workPointPressure: 0,
                    workPointPerformance: 0,
                    workPointPerformanceHour: 0
                };

                if (this.$store.state.selectedWorkPoint) {
                    selectedWorkPointCopy.workPointPressure = this.$store.state.selectedWorkPoint.workPointPressure;
                    selectedWorkPointCopy.workPointPerformance = this.$store.state.selectedWorkPoint.workPointPerformance;
                    selectedWorkPointCopy.workPointPerformanceHour = this.$store.state.selectedWorkPoint.workPointPerformanceHour;
                }

                this.calculateFans();

                if (this.$store.state.selectedWorkPoint) {
                    this.obiekt.graphsSummary.data.workPointPressure = selectedWorkPointCopy.workPointPressure;
                    this.obiekt.graphsSummary.data.workPointPerformance = selectedWorkPointCopy.workPointPerformance;
                    this.obiekt.graphsSummary.data.workPointPerformanceHour = selectedWorkPointCopy.workPointPerformanceHour;

                    this.obiekt.graphsSummary.changed.call(this);
                }
            },
            workPointPressureType() {
                // this.obiekt.calc();
                //
                // this.calculateFans();
            },
            workPointPerformance: function (newValue, oldValue) {
                if (window.mouseDown || (Object.is(newValue, NaN) && Object.is(oldValue, NaN)))
                    return;

                this.obiekt.refreshAmountUnit();
                // this.obiekt.calc();
                //
                // this.calculateFans();
            },

            workPointTemperature(newValue, oldValue) {
                if (window.mouseDown || (Object.is(newValue, NaN) && Object.is(oldValue, NaN)))
                    return;

                this.obiekt.refreshAirDensity();
                //    this.obiekt.calc();

                //    this.calculateFans();
            },

            workPointAboveSea(newValue, oldValue) {
                if (window.mouseDown || (Object.is(newValue, NaN) && Object.is(oldValue, NaN)))
                    return;

                this.obiekt.refreshAirDensity();
                // this.obiekt.calc();

                // this.calculateFans();
            },

            workPointAmount: function (newValue, oldValue) {
                if (window.mouseDown || (Object.is(newValue, NaN) && Object.is(oldValue, NaN)))
                    return;

                let dataObject = {
                    "this": "workPointAmount",
                    "workPointPerformance": this.workPointPerformance,
                    "workPointAmount": newValue,
                    "workPointAmountUnit": this.workPointAmountUnit
                }

                let needChange = this.checkChanges(dataObject);

                if (needChange || (Object.is(newValue, NaN) && Object.is(oldValue, NaN))) {
                    let returnedData = this.obiekt.refreshAmountUnit();
                    //   this.obiekt.calc();
                    this.manageReturnedData(returnedData, dataObject);
                }

                // this.calculateFans();
            },

            workPointAmountUnit: function (newValue, oldValue) {
                if (window.mouseDown)
                    return;

                let dataObject = {
                    "this": "workPointAmountUnit",
                    "workPointPerformance": this.workPointPerformance,
                    "workPointAmount": this.workPointAmount,
                    "workPointAmountUnit": newValue
                };

                let needChange = this.checkChanges(dataObject);

                if (needChange) {
                    let returnedData = this.obiekt.refreshAmount();
                    //  this.obiekt.calc();
                    this.manageReturnedData(returnedData, dataObject);
                }
            },

            workPointFrequency: function (newValue, oldValue) {
                // NVS-200 - dodanie zabezpieczenia na this.obiekt.graphsSummary
                if (window.mouseDown || (Object.is(newValue, NaN) && Object.is(oldValue, NaN)) || !this.obiekt.graphsSummary)
                    return;

                let dataObject = {
                    "this": "workPointFrequency",
                    "workPointFrequency": newValue,
                    "workPointRotationSpeed": this.workPointRotationSpeed
                }

                let needChange = this.checkChanges(dataObject);

                if (needChange) {
                    let returnedData = this.obiekt.refreshRotationSpeed();
                    // this.obiekt.calc();
                    this.manageReturnedData(returnedData, dataObject);
                }

                // this.calculateFans();
            },

            workPointRotationSpeed: function (newValue, oldValue) {
                //NV-200 - dodanie zabezpieczenia na this.obiekt.graphsSummary
                if (window.mouseDown || (Object.is(newValue, NaN) && Object.is(oldValue, NaN)) || !this.obiekt.graphsSummary)
                    return;

                let dataObject = {
                    "this": "workPointRotationSpeed",
                    "workPointFrequency": this.workPointFrequency,
                    "workPointRotationSpeed": newValue
                }

                let needChange = this.checkChanges(dataObject);

                if (needChange) {
                    let returnedData = this.obiekt.refreshFrequency();
                    //   this.obiekt.calc();
                    this.manageReturnedData(returnedData, dataObject);
                }

                // this.calculateFans();
            },

            workPointBaseFrequency50: function (newValue, oldValue) {
                if (newValue) {
                    this.obiekt.refreshWorkPointBaseFrequency(50);
                } else {
                    this.obiekt.refreshWorkPointBaseFrequency(60);
                }
                // this.obiekt.calc();
                //
                // this.calculateFans();
            },
        },
        methods: {

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            manageSelectedFan() {
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            },

            openCadHeader() {
                this.cadHeaderVisible = !this.cadHeaderVisible;
            },

            calculateFans() {
                //this.obiekt.init(this.$store);
                this.obiekt.refreshAxis();
                // this.obiekt.refreshAmountUnit();
                // this.obiekt.refreshAmount();
                // this.obiekt.refreshAirDensity();
                // this.obiekt.refreshRotationSpeed();
                // this.obiekt.refreshFrequency();
                //
                // if (this.$store.state.fourthStepParametersSelected['network_frequency'].options[0].elements[0].active) {
                //     this.obiekt.refreshWorkPointBaseFrequency(50);
                // } else {
                //     this.obiekt.refreshWorkPointBaseFrequency(60);
                // }

                if (this.$store.state.fourthStepParametersSelected['network_frequency'].options[0].elements[0].active) {
                    this.obiekt.refreshAllData(50);
                } else {
                    this.obiekt.refreshAllData(60);
                }

                this.obiekt.calc();
                this.obiekt.graphsSummary.draw();

                //this.calculateFans();

                if (this.$store.state.selectedFan) {

                    this.$store.commit({
                        type: 'toggleAdjustResultBtn',
                        disabled: false
                    })
                }
            },
            loadChangedUnit(unitType, typeName) {
                if (this.$store.state.fourthStepParamsLastUnitChanges.param_id == unitType)
                    this.obiekt.graphsSummary.getUnitObject().selectUnitOfTypeName(typeName, this.$store.state.fourthStepParamsLastUnitChanges.unit.id);
            },
            manageReturnedData(returnedData, dataObject) {
                for (let value in returnedData) {
                    if (dataObject.hasOwnProperty(value))
                        dataObject[value] = returnedData[value];
                }

                this.checkChanges(dataObject);
            },
            checkChanges(obj) {
                if (!window.storeStates)
                    window.storeStates = [];

                let needChange = true;
                let needPushObject = true;

                for (let value in obj) {
                    if (isFinite(obj[value]))
                        obj[value] = parseFloat(obj[value]);
                }

                for (let i = 0; i < window.storeStates.length; i++) {
                    if (this.compareKeys(window.storeStates[i], obj)) {
                        needPushObject = false;

                        if (this.compareThisValue(window.storeStates[i], obj))
                            needChange = false;
                        else {
                            delete obj['this'];
                            window.storeStates[i] = obj;
                        }

                        break;
                    }
                }

                if (needPushObject) {
                    delete obj['this'];
                    window.storeStates.push(obj);
                }

                return needChange;
            },
            compareKeys(a, b) {
                let aKeys = Object.keys(a).sort();
                let bKeys = Object.keys(b).sort();

                aKeys.forEach((val, key) => {
                    val == "this" ? aKeys.splice(key, 1) : ""
                });

                bKeys.forEach((val, key) => {
                    val == "this" ? bKeys.splice(key, 1) : ""
                });

                return JSON.stringify(aKeys) === JSON.stringify(bKeys);
            },
            compare(a, b) {
                return JSON.stringify(a) === JSON.stringify(b);
            },
            compareWithoutThis(a, b) {
                let a_cp = Object.assign({}, a);
                let b_cp = Object.assign({}, b);

                if (a_cp.hasOwnProperty("this")) {
                    delete a_cp[a_cp['this']];
                    delete b_cp[a_cp['this']];
                    delete a_cp['this'];
                }

                if (b.hasOwnProperty("this")) {
                    delete b_cp[b_cp['this']];
                    delete a_cp[b_cp['this']];
                    delete b_cp['this'];
                }

                return this.compare(a_cp, b_cp);
            },
            compareThisValue(a, b) {
                let a_cp = Object.assign({}, a);
                let b_cp = Object.assign({}, b);

                let thisProperty = "";

                if (a_cp.hasOwnProperty("this")) {
                    thisProperty = a_cp['this'];
                }

                if (b.hasOwnProperty("this")) {
                    thisProperty = b_cp['this'];
                }

                for (let key in a_cp) {
                    if (key != thisProperty) {
                        delete a_cp[key];
                    }
                }

                for (let key in b_cp) {
                    if (key != thisProperty) {
                        delete b_cp[key];
                    }
                }

                return this.compare(a_cp, b_cp);
            }
        },


        mounted() {
            this.$root.$on('disabledCadTable', () => {
                this.cadHeaderVisible = false;
            })

            this.obiekt = measurementShow;
            window.measurementShow = this.obiekt;

            if (this.$store.state.activeFun && this.$store.state.workPointParameters.elements['work_frequency'] && this.$store.state.workPointParameters.elements['work_frequency'].value)
                this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = this.$store.state.workPointParameters.elements['work_frequency'].value;
            else
                this.$store.state.fourthStepParametersSelected['workPointFrequency'].value = this.$store.state.fourthStepParameters['workPointFrequency'].value;

            if (this.$store.state.selectedFan && this.$store.state.selectedFan.engine_rpm) {
                this.$store.state.fourthStepParametersSelected['workPointRotationSpeed'].value = this.$store.state.fourthStepParametersSelected['workPointFrequency'].value / 50 * parseFloat(this.$store.state.selectedFan.engine_rpm);
            }

            this.obiekt.init(this.$store);

            if (this.offerView) {
                this.obiekt.graphsSummary.data.workPointPressure = this.$store.state.selectedWorkPoint.workPointPressure;
                this.obiekt.graphsSummary.data.workPointPerformance = this.$store.state.selectedWorkPoint.workPointPerformance;
                this.obiekt.graphsSummary.data.workPointPerformanceHour = this.$store.state.selectedWorkPoint.workPointPerformanceHour;
                this.obiekt.graphsSummary.changed.call(this);
                return;
            }

            this.obiekt.refreshAllData(this.$store.state.fourthStepParametersSelected['workPointFrequency'].value);

            if (this.$store.state.selectedWorkPoint && !(this.$store.state.productCard.custom.is_approved !== undefined && this.$store.state.productCard.custom.is_approved === true)) {
                this.obiekt.graphsSummary.data.workPointPressure = this.$store.state.selectedWorkPoint.workPointPressure;
                this.obiekt.graphsSummary.data.workPointPerformance = this.$store.state.selectedWorkPoint.workPointPerformance;
                this.obiekt.graphsSummary.data.workPointPerformanceHour = this.$store.state.selectedWorkPoint.workPointPerformanceHour;

                this.obiekt.graphsSummary.changed.call(this);

                this.$store.state.selectedWorkPoint.locked = false;
            } else {
                this.$store.state.selectedWorkPoint = {
                    locked: false,
                    workPointPressure: 0,
                    workPointPerformance: 0,
                    workPointPerformanceHour: 0,
                };
            }

            if ((!this.$store.state.productCard.workPointInitialLoaded && this.$store.state.productCard.loaded) || this.$store.state.productCard.custom.is_approved) {
                this.$store.state.setWorkPointWhenFanHandlerFired = true;
                this.$store.state.selectedWorkPoint.locked = false;
                if (this.$store.state.productCard.savedWorkPoint) {
                    this.obiekt.graphsSummary.data.workPointPressure = this.$store.state.productCard.savedWorkPoint.workPointPressure;
                    this.obiekt.graphsSummary.data.workPointPerformance = this.$store.state.productCard.savedWorkPoint.workPointPerformance;
                    this.obiekt.graphsSummary.data.workPointPerformanceHour = this.$store.state.productCard.savedWorkPoint.workPointPerformanceHour;
                }
                this.obiekt.graphsSummary.changed.call(this);
                this.$store.state.productCard.workPointInitialLoaded = true;
            }
        },

        beforeDestroy() {
            // NVS-200 - dodanie zabezpieczenia na this.obiekt.graphsSummary
            if (!this.offerView && this.obiekt.graphsSummary) {
                this.$store.state.selectedWorkPoint = {
                    locked: true,
                    workPointPressure: this.obiekt.graphsSummary.data.workPointPressure,
                    workPointPerformance: this.obiekt.graphsSummary.data.workPointPerformance,
                    workPointPerformanceHour: this.obiekt.graphsSummary.data.workPointPerformanceHour,
                };
            }

            if (this.$store.state.productCard.custom.is_approved) {
                this.$store.state.setWorkPointWhenFanHandlerFired = true;
                this.$store.state.selectedWorkPoint.locked = false;
                if (this.$store.state.productCard.savedWorkPoint && this.obiekt.graphsSummary) {
                    this.obiekt.graphsSummary.data.workPointPressure = this.$store.state.productCard.savedWorkPoint.workPointPressure;
                    this.obiekt.graphsSummary.data.workPointPerformance = this.$store.state.productCard.savedWorkPoint.workPointPerformance;
                    this.obiekt.graphsSummary.data.workPointPerformanceHour = this.$store.state.productCard.savedWorkPoint.workPointPerformanceHour;
                }
                //TODO: TO ONE METHOD
                if (this.obiekt.graphsSummary) {
                    this.obiekt.graphsSummary.changed.call(this);
                }
            }
            this.$root.$off('disabledCatTable');
        }
    }
</script>